import { render, staticRenderFns } from "./SuitesListModal.vue?vue&type=template&id=223469a2&scoped=true"
import script from "./SuitesListModal.vue?vue&type=script&lang=ts"
export * from "./SuitesListModal.vue?vue&type=script&lang=ts"
import style0 from "./SuitesListModal.vue?vue&type=style&index=0&id=223469a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223469a2",
  null
  
)

export default component.exports